import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateEmbed } from '../../actions/embedActions';

export class EmbedCloseButton extends Component {
  handleCloseOverlayClick = (event) => {
    this.props.updateEmbed({ showing: false })
    setTimeout(() => {
      window.parent.postMessage({action: 'closeOverlay'}, '*')
    }, 300)
  }

  componentDidMount() {
    this.props.updateEmbed({ showing: true })
  }

  get renderCloseBtn() {
    const { location } = this.props.locator

    return (
      <div className={`closeby-overlay-close-btn ${location ? 'location-showing' : ''}`} onClick={this.handleCloseOverlayClick}>
        <svg className="closeby-overlay-close-btn-icon" width="15px" height="15px" viewBox="0 0 15 15">
          <g stroke="none" fill="none">
            <g transform="translate(-8468.000000, -3268.000000)" fill="#FFFFFF">
              <g transform="translate(8468.000000, 3268.000000)">
                <path d="M14.5396037,12.6845991 L9.78000456,7.925 L14.5396037,3.16540089 C15.0534654,2.65153911 15.0534654,1.8242581 14.5396037,1.31039633 C14.0257419,0.796534557 13.1984609,0.796534557 12.6845991,1.31039633 L7.925,6.06999544 L3.16540089,1.31039633 C2.65153911,0.796534557 1.8242581,0.796534557 1.31039633,1.31039633 C0.796534557,1.8242581 0.796534557,2.65153911 1.31039633,3.16540089 L6.06999544,7.925 L1.31039633,12.6845991 C0.796534557,13.1984609 0.796534557,14.0257419 1.31039633,14.5396037 C1.8242581,15.0534654 2.65153911,15.0534654 3.16540089,14.5396037 L7.925,9.78000456 L12.6845991,14.5396037 C13.1984609,15.0534654 14.0257419,15.0534654 14.5396037,14.5396037 C15.049821,14.0257419 15.049821,13.1948165 14.5396037,12.6845991 L14.5396037,12.6845991 Z" id="Shape"></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.props.embed.pageEmbed ? '' : this.renderCloseBtn}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state
  }
};

export default connect(mapStateToProps, { updateEmbed })(EmbedCloseButton);
